// FE-78 (21.10.2026): tıklanabilir div/span/li/img (~190 adet) klavyeyle kullanılamıyordu. Bunlara
// role="button" tabIndex={0} onKeyDown={klavyeIleTikla} eklendi (görünüm aynı; <button>'a çevirmek tarayıcı
// düğme stilleri yüzünden tasarımı bozardı). Enter/Space → öğenin kendi onClick'i (iç öğelerden gelen tuşlar
// — ör. içteki input — etkilenmez).
export function klavyeIleTikla(e) {
  if (e.target !== e.currentTarget) return;
  if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
    e.preventDefault();
    e.currentTarget.click();
  }
}
